<template>
  <div class="q-col-12 q-col-lg-3 q-pt-1 suggestions__container"
       :class="{'q-border-bottom q-px-0 q-pb-2': isMobileView}" id="suggestions__container" v-if="hasAnyResults">
    <p v-if="!isMobileView" class="q-text-muted q-col-12 suggestions__header q-mt-0 q-mb-0 q-fw-semibold q-text-start">
      {{ SmartSearchTranslations.autocomplete.suggestionsText }}</p>
    <ul id="suggestionsListNew" class="q-list-group q-list-group-flush q-w-100 q-px-0 suggestions__list">
      <SingleSuggestion v-for="suggestion in getNewSuggestions" :key="suggestion.query" :suggestion="suggestion"/>
    </ul>
    <template v-for="aggregation in displayAggregations" :key="aggregation.field">
      <p class="aggregation-suggestions__header q-text-muted q-fw-semibold q-mt-3 q-mb-1">
        {{ aggregation.label }}
      </p>
      <ul class="q-list-group q-list-group-flush q-w-100 q-px-0 aggregation-suggestions__list">
        <AggregationSuggestionItem
            v-for="item in aggregation.items"
            :key="`${aggregation.field}:${item.id}`"
            :field="aggregation.field"
            :item="item"
        />
      </ul>
    </template>
  </div>
</template>

<script setup lang="ts">
import { inject } from 'vue'
import {storeToRefs} from "pinia";
import SingleSuggestion from '@/components/AutocompletePopup/ShowResults/Suggestions/SingleSuggestion.vue';
import AggregationSuggestionItem from '@/components/AutocompletePopup/ShowResults/Suggestions/AggregationSuggestionItem.vue';
import {useSuggestionStore} from "@/store/AutocompletePopup/SuggestionStore";
import {usePopupStore} from "@/store/AutocompletePopup/PopupStore";
import {SmartSearchTranslationsInterface} from "@/core/types";
import {useMobileViewStore} from "@/store/MobileViewStore";
import {useAutocompleteAggregationsStore} from "@/store/AutocompletePopup/AutocompleteAggregationsStore";

const suggestionStore = useSuggestionStore()
const {getNewSuggestions} = storeToRefs(suggestionStore)
const mobileViewStore = useMobileViewStore();
const {isMobileView} = storeToRefs(mobileViewStore)

const popupStore = usePopupStore()
const {hasAnyResults} = storeToRefs(popupStore)

const autocompleteAggregationsStore = useAutocompleteAggregationsStore()
const {displayAggregations} = storeToRefs(autocompleteAggregationsStore)

// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const SmartSearchTranslations = inject<SmartSearchTranslationsInterface>('SmartSearchTranslations')!

</script>

<style scoped>
@media (max-width: 991.98px) {
  #suggestionsListNew {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: flex-start;
    overflow-x: scroll;
    gap: 0.5rem;
  }

  .aggregation-suggestions__header {
    display: none;
  }
}

.aggregation-suggestions__header {
  font-size: 0.75em;
  letter-spacing: 0.05em;
  text-align: left;
}
</style>
